import React from 'react';
import { useNavigate } from 'react-router';
import { Body5, Body7, Container, H5 } from '@ui';
import { FlatButton, SkeletonButton } from '@ui/buttons';
import { ROUTES } from '@constants/routes';
import { Consequence, MicroLabel, PassiveCard } from '@features/scoreSpec/styles';
import { writeTarget } from '@features/scoreSpec/environment';

// The done state, worded to match what actually happened.
//
// Create runs STRUCTURAL checks only — it never compiles the spec. An unpriced model, a JSONPath
// that matches nothing, a version that disagrees with the id and a broken template all pass here
// and fail later, at lock. So this does not say "valid" and it does not say "ready": it says a
// draft exists, drafts run nothing, and the next step is a preview against real documents.

export const DoneState = ({ record, changes, onStartAnother }) => {
  const navigate = useNavigate();
  const target = writeTarget();
  const specId = record.score_spec_id;

  return (
    <PassiveCard aria-label="Draft created">
      <H5>{`Draft created — ${specId}`}</H5>
      <Container top={8}>
        <Body5>
          It is not running yet. Preview it against real documents, then lock and approve it to start scoring.
        </Body5>
      </Container>
      <Container top={8}>
        <Consequence>
          {`Created in ${target.label} (${target.host}). Nothing was checked beyond the shape of the request — a compile only happens at lock, and it is the door with no way back.`}
        </Consequence>
      </Container>

      {changes.length > 0 && (
        <Container top={16}>
          <MicroLabel>Rewritten on the way out</MicroLabel>
          <Container top={8}>
            {changes.map((change) => (
              <Body7 key={change} isLowContrast>
                {change}
              </Body7>
            ))}
          </Container>
        </Container>
      )}

      <Container top={24} row verticallyCenter>
        <FlatButton onClick={() => navigate(`${ROUTES.scoreSpecSpecs}/${specId}`)}>Open the draft</FlatButton>
        <Container left={16}>
          <SkeletonButton onClick={onStartAnother}>Duplicate another</SkeletonButton>
        </Container>
      </Container>
    </PassiveCard>
  );
};
